export default __webpack_public_path__ + "static/media/vertical_collapse.9a8fb781.svg";